import type { BusinessDetails, GetOrganizationResponse } from '@pillar-portal/api-types';

function formatBusinessDetailsDisplayName(
    businessDetails?: BusinessDetails
): string | null {
    const dba: string | undefined = businessDetails?.dba?.trim();
    if (dba !== undefined && dba.length > 0) {
        return dba;
    }
    const legalEntityName: string | undefined =
        businessDetails?.legalEntityName?.trim();
    if (legalEntityName !== undefined && legalEntityName.length > 0) {
        return legalEntityName;
    }
    return null;
}

export function formatOrganizationDisplayName(
    organization: Pick<GetOrganizationResponse, 'name' | 'businessDetails'>
): string {
    return (
        formatBusinessDetailsDisplayName(organization.businessDetails) ??
        organization.name
    );
}
